import { createContext, useContext, useCallback, useState } from 'react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbContextValue {
  items: BreadcrumbItem[];
  setItems: (items: BreadcrumbItem[]) => void;
}

export const BreadcrumbContext = createContext<BreadcrumbContextValue>({
  items: [],
  setItems: () => undefined,
});

export function useBreadcrumbs() {
  return useContext(BreadcrumbContext);
}

export function useBreadcrumbProvider() {
  const [items, setItemsState] = useState<BreadcrumbItem[]>([]);

  const setItems = useCallback((newItems: BreadcrumbItem[]) => {
    setItemsState(newItems);
  }, []);

  return { items, setItems };
}
